import { useState } from 'react';

export const useWaveformLoadingWebsites = () => {
  const [loadingFields, setLoadingFields] = useState({});

  const startLoading = (fieldName) => {
    setLoadingFields(prev => ({ ...prev, [fieldName]: true }));
  };

  const stopLoading = (fieldName) => {
    setLoadingFields(prev => ({ ...prev, [fieldName]: false }));
  };

  return { loadingFields, startLoading, stopLoading };
};
